import { useEffect } from 'react';

/**
 * @param {*} ref
 * @param {Function} cb
 */
function useClickOutside(ref, cb) {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    /**
     * @param {MouseEvent} event
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cb();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
  /* eslint-enable react-hooks/exhaustive-deps */
}
export default useClickOutside;
